var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Do not edit this file, it is auto generated
 */
import { StyledSvgIcon } from '../../styles/svg-icon.styled';
export const ArrowRightIcon = (_a) => {
    var { size = 'md' } = _a, props = __rest(_a, ["size"]);
    return (_jsx(StyledSvgIcon, Object.assign({ xmlSpace: "preserve", viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", "$size": size }, props, { children: _jsx("path", { d: "M31.447 15.94c.011-.082.052-.157.053-.241l-.002-.011.002-.011c0-.581-.243-1.102-.63-1.478-.006-.006-.008-.015-.014-.021L20.652 4.491a2.066 2.066 0 0 0-2.845 2.997l6.449 6.122H2.567a2.067 2.067 0 0 0 0 4.134h21.521l-7.411 6.738a2.066 2.066 0 1 0 2.782 3.057l11.367-10.333c.012-.011.016-.027.028-.038a2 2 0 0 0 .341-.47c.039-.068.099-.122.131-.194.073-.174.095-.369.121-.564" }) })));
};
